"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.PrevisuPasseSeul = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _previsuPasse = require("./previsuPasse");

var PrevisuPasseSeul = function PrevisuPasseSeul(props) {
  var pageProduit = props.pageProduit,
      product = props.product,
      showDimensions = props.showDimensions,
      size = props.size,
      couleurInterieur = props.couleurInterieur,
      dimSaisies = props.dimSaisies,
      handleUpdate = props.handleUpdate,
      aspectProduit = props.aspectProduit;
  var cmToPx = size / (pageProduit.largeur * pageProduit.pp.ouvertures[0] + (pageProduit.pp.margeG + pageProduit.pp.margeD) + pageProduit.pp.interL * (pageProduit.pp.ouvertures[0] - 1));

  if (pageProduit.hauteur * pageProduit.pp.ouvertures[1] + (pageProduit.pp.margeH + pageProduit.pp.margeB) * pageProduit.pp.ouvertures[1] > 80) {
    cmToPx = size * 600 / 400 / (pageProduit.hauteur * pageProduit.pp.ouvertures[1] + (pageProduit.pp.margeH + pageProduit.pp.margeB) + pageProduit.pp.interL * (pageProduit.pp.ouvertures[1] - 1));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: " mt-3",
    style: {
      height: ((pageProduit.hauteur + pageProduit.pp.margeH + pageProduit.pp.margeB) * pageProduit.pp.ouvertures[1] + pageProduit.pp.ouvertures[1] * (pageProduit.pp.margeH + pageProduit.pp.margeB)) * cmToPx,
      marginLeft: props.size == 90 ? 30 : 0,
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_previsuPasse.PrevisuPasse, {
    aspectProduit: aspectProduit,
    cmToPx: cmToPx,
    product: product,
    pageProduit: pageProduit,
    showDimensions: showDimensions,
    size: size,
    handleUpdate: handleUpdate,
    dimSaisies: dimSaisies,
    couleurInterieur: couleurInterieur
  }));
};

exports.PrevisuPasseSeul = PrevisuPasseSeul;
PrevisuPasseSeul.defaultProps = {
  size: 90,
  showDimensions: false,
  dimSaisies: null,
  pageProduit: {
    hauteur: 10,
    largeur: 10,
    pp: {
      ouvertures: [1, 1],
      margeG: 5,
      margeH: 5,
      margeD: 5,
      margeB: 5,
      interL: 5,
      interH: 5
    }
  }
};
PrevisuPasseSeul.propTypes = {
  pageProduit: _propTypes.default.object.isRequired,
  product: _propTypes.default.object.isRequired,
  showDimensions: _propTypes.default.bool,
  size: _propTypes.default.number,
  aspectProduit: _propTypes.default.object,
  dimSaisies: _propTypes.default.object,
  handleUpdate: _propTypes.default.func,
  couleurInterieur: _propTypes.default.string
};
var _default = PrevisuPasseSeul;
exports.default = _default;